// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-content[data-v-cd6c007c] img{-o-object-fit:cover;object-fit:cover;}.blog-content[data-v-cd6c007c] img{max-height:350px;}@media (min-width: 768px){.blog-content[data-v-cd6c007c] img{max-height:500px;}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
